import { render, staticRenderFns } from "./OfferRequirements.vue?vue&type=template&id=1bd68f2f&scoped=true"
import script from "./OfferRequirements.vue?vue&type=script&lang=js"
export * from "./OfferRequirements.vue?vue&type=script&lang=js"
import style0 from "./OfferRequirements.vue?vue&type=style&index=0&id=1bd68f2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd68f2f",
  null
  
)

export default component.exports